import React, { useEffect, useState, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import EnvelopeIcon from '@8x8/oxygen-icon/icons/EnvelopeIcon';
import ArrowLeftSmallIcon from '@8x8/oxygen-icon/icons/ArrowLeftSmallIcon';
import { translate } from '~/services/translate';

import auth0 from '../services/auth0';
import StyledInput from './basic/styled-input';
import { validateEmail } from '../core/utils';
import Button from './basic/button';
import { MOBILE_THRESHOLD } from '../core/constants';
import analytics from '../services/amplitude';
import { FlexCentered } from '~/components/basic/containers';

const ResetPasswordTitle = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  margin: 0 auto 32px;
`;

const ResetPasswordDescription = styled.div`
  font-size: 15px;
  line-height: 24px;
  margin: 0 auto 16px;
`;

const BackToMainScreenContainer = styled(FlexCentered)`
  font-weight: 600;
  font-size: 15px;
  color: ${({ theme }) => theme.lightBlue};
  justify-content: center;
  cursor: pointer;
  line-height: 20px;

  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    line-height: 48px;
  }
`;

const ResetPassword = ({ switchToMainView }) => {
  const theme = useContext(ThemeContext);
  const [email, setEmail] = useState('');
  const [continueDisabled, setContinueDisabled] = useState(true);

  useEffect(() => {
    analytics.trackPageView(analytics.PAGE_NAMES.RESET_PASSWORD);
  }, []);

  const handleEmailChange = event => {
    const mail = event.target.value;
    setEmail(mail);
    setContinueDisabled(!validateEmail(mail));
  };

  const onSendEmail = () => {
    analytics.trackEvent(analytics.EVENT_NAMES.RESET_PASSWORD, { email });
    auth0.resetPassword(email);
    switchToMainView();
  }

  return (
    <>
      <ResetPasswordTitle>{translate('reset_password_title')}</ResetPasswordTitle>
      <ResetPasswordDescription>{translate('reset_password_description')}</ResetPasswordDescription>
      <StyledInput
        iconLeft={EnvelopeIcon}
        type="email"
        placeholder="email@example.com"
        onChange={handleEmailChange}
        value={email}
      />
      <Button
        data-test-id="button-send-email"
        backgroundColor={theme.lightBlue}
        backgroundColorHover="#278ADF"
        callback={onSendEmail}
        text={translate('send_email')}
        disabled={continueDisabled}
      />
      <BackToMainScreenContainer onClick={switchToMainView}>
        <ArrowLeftSmallIcon color={theme.lightBlue} />
        <span>{translate('back_to_login')}
        </span>
      </BackToMainScreenContainer>
    </>
  );
}

ResetPassword.propTypes = {
  switchToMainView: PropTypes.func,
}

export default ResetPassword;